import { render, staticRenderFns } from "./BetgameName.vue?vue&type=template&id=09b94dad&scoped=true"
import script from "./BetgameName.vue?vue&type=script&lang=js"
export * from "./BetgameName.vue?vue&type=script&lang=js"
import style0 from "./BetgameName.vue?vue&type=style&index=0&id=09b94dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b94dad",
  null
  
)

export default component.exports